/* eslint-disable no-unused-expressions */
import { useEffect, useRef } from 'react'

export function useDidMountEffect(fn, inputs) {
    const didMountRef = useRef(false)

    useEffect(() => {
        if (didMountRef.current) {
            fn()
        } else {
            didMountRef.current = true
        }
    }, inputs)
}
